import {Component} from '@angular/core';
import {AppRoutes} from "../../enums/routes";
import {CookieService} from "../../_services/cookie.service";
import {NavbarItemLargeComponent} from "../navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../navbar-base/navbar-container/navbar-container.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-navbar-help',
  templateUrl: './navbar-help.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-help.component.scss']
})
export class NavbarHelpComponent {
  protected readonly Routes = AppRoutes;
  protected readonly window = window;

  // No PermissionService here any more: the only permission-gated entry was Changelog, which #229 removed from
  // this navbar (the route keeps its own AuthGuard + Permissions_ChangelogComponent gate). Everything else in
  // the Hilfe navbar is available to every session.
  constructor(public CookieService: CookieService) {
  }
}
